import { SettlementMethodContainerModel } from
  '../../../../../models/aggregates/settlement-method/settlement-method-container.model';
import { SettlementMethodExtContainerModel } from
  '../../../../../models/aggregates/settlement-method/settlement-method-ext-container.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa } from '../shared/api-visa.model';
import { BasicApiResponseModel } from '../shared/api-response.model';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })
export class SettlementMethodService extends BaseApiPublicLoginTemplateService<SettlementMethodContainerModel, SettlementMethodContainerModel, SettlementMethodContainerModel> {

  readonly url = Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'erp/settlement-methods';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'erp/settlement-methods';
    this.endpoint_path_login_url = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'erp/settlement-methods/' + BaseApiPublicLoginTemplateService.LOGIN_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'erp/settlement-methods/' + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;
    this.httpClient = http;
  }

  public privateKeyUpload(
    visa: ApiVisa,
    formData: FormData,
    hdrGuid): Promise<BasicApiResponseModel<SettlementMethodExtContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/private-key/' + hdrGuid;
    return this.httpClient.post<BasicApiResponseModel<SettlementMethodExtContainerModel>>
      (Url, formData, this.getHttpHeader(visa))
      .toPromise();
  }

  public currentFpxPublicCertUpload(
    visa: ApiVisa,
    formData: FormData,
    hdrGuid): Promise<BasicApiResponseModel<SettlementMethodExtContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/current-fpx-public-cert-upload/' + hdrGuid;
    return this.httpClient.post<BasicApiResponseModel<SettlementMethodExtContainerModel>>
      (Url, formData, this.getHttpHeader(visa))
      .toPromise();
  }

  public nextFpxPublicCertUpload(
    visa: ApiVisa,
    formData: FormData,
    hdrGuid): Promise<BasicApiResponseModel<SettlementMethodExtContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/next-fpx-public-cert-upload/' + hdrGuid;
    return this.httpClient.post<BasicApiResponseModel<SettlementMethodExtContainerModel>>
      (Url, formData, this.getHttpHeader(visa))
      .toPromise();
  }

  public getSettlementMethodFpxPublicCert(
    visa: ApiVisa,
    extGuid: string): Observable<Blob> {

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/fpx-public-cert/' + extGuid;

    return this.httpClient.get<Blob>(
      Url,
      {
        headers: new HttpHeaders({
          authorization: visa.jwt_secret,
          responseType: 'blob',
          tenantCode: visa.tenantCode,
          appId: '10'
        }),
        responseType: 'blob' as 'json'
      });
  }

  getSettlementMethodByHdrGuids(guid: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url = visa.api_domain_url + this.endpoint_path + '/query?hdr_guids=' + guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url, this.getHttpHeader(visa)
    );
  }
}
